import React from 'react';

import { Filter, SearchNameOrEmail } from '../../../organisations/users/OrganisationUserToolbar';

const LAST_LOGIN_OPTIONS = () => [
    { value: 'any', label: $t('Last login: any time') },
    { value: '30d', label: $t('Last login: last 30 days') },
    { value: 'never', label: $t('Last login: never') },
];

/**
 * Search and filters above the Manage Users table. An empty filter is sent as no filter.
 */
export default function ProjectUsersToolbar({ query, searchInput, roles, departments, venues, modules, onSearchChange, onChange }) {
    return (
        <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-3">
            <SearchNameOrEmail value={searchInput} onChange={onSearchChange} />

            <Filter
                id="project_users_role"
                widthClassName="tw-w-[130px]"
                label={$t('Role')}
                value={query.role_id}
                onChange={(roleId) => onChange({ role_id: roleId })}
            >
                <option value="">{$t('All roles')}</option>
                {roles.map((role) => (
                    <option key={role.id} value={role.id}>
                        {$t(role.name)}
                    </option>
                ))}
            </Filter>

            <Filter
                id="project_users_department"
                widthClassName="tw-w-[180px]"
                label={$t('Department')}
                value={query.department_id}
                onChange={(departmentId) => onChange({ department_id: departmentId })}
            >
                <option value="">{$t('All departments')}</option>
                {departments.map((department) => (
                    <option key={department.id} value={department.id}>
                        {department.name}
                    </option>
                ))}
            </Filter>

            <Filter
                id="project_users_venue"
                widthClassName="tw-w-[130px]"
                label={$t('Venue')}
                value={query.venue_id}
                onChange={(venueId) => onChange({ venue_id: venueId })}
            >
                <option value="">{$t('All venues')}</option>
                {venues.map((venue) => (
                    <option key={venue.id} value={venue.id}>
                        {venue.name}
                    </option>
                ))}
            </Filter>

            <Filter
                id="project_users_module"
                widthClassName="tw-w-[130px]"
                label={$t('Module')}
                value={query.module_id}
                onChange={(moduleId) => onChange({ module_id: moduleId })}
            >
                <option value="">{$t('All modules')}</option>
                {modules.map((module) => (
                    <option key={module.id} value={module.id}>
                        {module.name}
                    </option>
                ))}
            </Filter>

            <Filter
                id="project_users_last_login"
                widthClassName="tw-w-[158px]"
                label={$t('Last login')}
                value={query.last_login}
                onChange={(lastLogin) => onChange({ last_login: lastLogin ?? 'any' })}
            >
                {LAST_LOGIN_OPTIONS().map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </Filter>
        </div>
    );
}
